import React from "react";
import { NavLink } from "react-router-dom";
import { cleanDate } from "../../../util/app";
import dummyImage from "../../../img/image.png";

const PatientBasicList = ({ patients }) => {
    return (
        <table className="table table-hover table-bordered">
            <thead>
                <tr>
                    <th className="text-center">Image</th>
                    <th> Name </th>
                    <th> NHS </th>
                    <th> Gender </th>
                    <th> Created At </th>
                    <th className="text-center"> Profile </th>
                </tr>
            </thead>

            <tbody>
                {patients.map((patient) => (
                    <tr className="odd gradeX" key={patient.id}>
                        <td className="patient-img">
                            <center>
                                <div
                                    style={{
                                        backgroundImage: `url(${patient.profile_picture || dummyImage}`,
                                        width: "50px",
                                        height: "50px",
                                    }}
                                    className="img-container doctor-pic custom-img"
                                ></div>
                            </center>
                        </td>
                        <td>
                            <strong>{patient.name}</strong>
                            <div>{patient.admitted ? <span className="label label-sm label-success">InPatient</span> : <span className="label label-sm label-pink">OutPatient</span>}</div>
                        </td>
                        <td>{patient.hcn}</td>
                        <td>{patient.gender}</td>
                        <td>
                            {cleanDate(patient.created_at, true, false)}
                            {/* <TimeAgo date={patient.created_at} /> */}
                        </td>
                        <td className="text-center">
                            <NavLink
                                to={{
                                    pathname: `/home/patient/profile/${patient.id}`,
                                }}
                                className="btn btn-tbl-edit btn-xs"
                            >
                                <i className="fa fa-user"></i>
                            </NavLink>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default PatientBasicList;
